var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"container",attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"sticky-col"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }